import { constants } from '@/lib/constants';

const localState = {
  cachedGlAccounts: {},
  inFlight: false,
};

const localGetters = {
  cachedGlAccounts: state => companyId => {
    return state.cachedGlAccounts[companyId];
  },

  getAllGlAccounts: state => state.cachedGlAccounts,

  inFlight: state => state.inFlight,
};

const localActions = {
  /**
   * Get all glaccounts for a given companyid
   * @param {string} payload.companyid id of company to be queried
   */
  async getGlAccounts({ dispatch, commit, rootGetters }, payload) {
    const { companyid } = payload;

    const cachedResults = rootGetters['glAccount/cachedGlAccounts'](companyid);
    if (cachedResults) return cachedResults;

    try {
      commit('set_in_flight', true);
      const queryPayload = {
        url: '/tg/glaccount/query',
        params: {
          q: `companyid-${constants.EQUALS}${companyid}${constants.DELIM}enabled-${constants.EQUALS}Y`,
          orderby: 'accountid',
          limit: 'None',
          serialize: '_ui_label',
        },
      };
      const { results, errors } = await dispatch('editObject/query', queryPayload, { root: true });

      if (errors || !results.length) {
        dispatch('notify/push', {
          title: 'Error',
          text: `G/L Accounts not found for company: ${companyid}`,
        }, { root: true });
        return;
      }

      commit('set_cached_gl_accounts', { results, companyid });
      return results;
    } finally {
      commit('set_in_flight', false);
    }
  },
  /**
   * Dispatches action to get account description
   * @param {string} payload.path path to object prop to be updated
   * @param {string} payload.accountid id of account to be queried
   * @param {string} payload.companyid id of company to be queried
   */
  async setAccountDescription({ dispatch }, payload) {
    const { path, accountid, companyid } = payload;
    const queryPayload = {
      url: '/tg/glaccount/get',
      params: { accountid, companyid },
    };
    const { results } = await dispatch('editObject/query', queryPayload, { root: true });

    const [accountDescription] = results;

    if (!accountDescription) {
      dispatch('notify/push', {
        title: 'Error',
        text: 'G/L Account not found',
      }, { root: true });
      return;
    }

    dispatch('editObject/updateValue', {
      path,
      key: 'glaccountdescription',
      value: accountDescription.description,
    }, { root: true });
  },

  /**
   * Dispatches action to update account descriptions for existing rows
   * @param {Array} payload.details array of detail objects
   * @param {string} payload.detailPath path for array of detail objects
   */
  async fetchAccountDescriptions({ dispatch }, payload) {
    let path;
    let value;
    const details = payload.details;
    for (const detail of details) {
      path = `record.${payload.detailPath}[${details.indexOf(detail)}]`;
      value = detail.glaccount.accountid;
      await dispatch('setAccountDescription', {
        path,
        accountid: value,
        companyid: detail.companyid,
      });
    }
  },

  clearStaleGlAccounts({ commit }) {
    commit('clear_stale_gl_accounts');
  },
};

const localMutations = {
  set_cached_gl_accounts(state, payload) {
    state.cachedGlAccounts[payload.companyid] = payload.results;
  },

  clear_stale_gl_accounts(state) {
    state.cachedGlAccounts = {};
  },

  set_in_flight(state, bool) {
    state.inFlight = bool;
  },
};

export default {
  namespaced: true,
  state: localState,
  getters: localGetters,
  actions: localActions,
  mutations: localMutations,
};
